import axiosClient from "apis/axios-client";


export interface InitialSignupConfigAPI {
  id: number;
  configName: string;
  configurationType: string;
  creditAmount: number;
  promoLimit: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  startDate: string;
  endDate: string;
}

export interface SignupCreditsRequest {
  ConfigName: string;
  CreditAmount: number;
  PromoLimit: number;
  ConfigurationType: string;
  AirlineIds: number[];
  StartDate: string;
  EndDate: string;
  IsActive?: boolean;
}

export interface InitialSignupUpdate {
  id: number;
  configName: string;
  configurationType: string;
  creditAmount: number;
  promoLimit: number;
  startDate: string;
  endDate: string;
  isActive: boolean;
  airlineIds?: number[];

}


export interface GetInitialSignupConfigurationResponse {
  totalRecords: number;
  data: InitialSignupConfigAPI[];
}

interface BaseApiResponse {
  message: string;
  records?: number;
}

interface UpdateApiResponse {
  success: boolean;
  message?: string;
  error?: string;
}

export interface GetInitialSignupConfigurationParams {
  Search?: string;
  IsPromo?: boolean;
  IsActive?: boolean;
  PageNumber?: number;
  PageSize?: number;
}

interface DeleteInitialSignupConfigurationParams {
  id: number;
}

export const getInitialSignupConfiguration = async (
  params: GetInitialSignupConfigurationParams = {}
): Promise<GetInitialSignupConfigurationResponse> => {
  try {
    const response = await axiosClient.get<GetInitialSignupConfigurationResponse>(

      '/admin/AdminCredit/GetSignupCredits',

      { params: params }
    ) as unknown as GetInitialSignupConfigurationResponse;

    return response;
  } catch (error) {
    console.error('Error fetching InitialSignup configuration:', error);
    throw error;
  }
};


export const addInitialSignupConfiguration = async (
  configData: SignupCreditsRequest
): Promise<BaseApiResponse> => {
  try {
    const response = await axiosClient.post<BaseApiResponse>(
      '/admin/AdminCredit/AddSignupCredits',
      null,
      {
        params: configData,
        paramsSerializer: {
          indexes: null,
        },
      }
    ) as unknown as BaseApiResponse;
    return response;
  } catch (error: any) {
    console.error('Error in addInitialSignupConfiguration:', error);

    const errorMessage = error.response?.data?.message
      || error.response?.data?.detail
      || 'An unknown network error occurred while adding configuration.';

    throw new Error(errorMessage);
  }
};


export const deleteInitialSignupConfiguration = async (
  id: number
): Promise<void> => {
  try {
    await axiosClient.delete(
      "/admin/AdminCredit/DeleteSignupCreditConfig",
      {
        data: id,
      }
    );
  } catch (error) {
    console.error("Error deleting signup credit configuration:", error);
    throw error;
  }
};

export const updateInitialSignupConfiguration = async (
  config: InitialSignupUpdate
): Promise<{ message: string }> => {
  const params = {
    id: config.id,
    ConfigName: config.configName,
    CreditAmount: config.creditAmount,
    PromoLimit: config.promoLimit,
    ConfigurationType: config.configurationType,
    AirlineIds: config.airlineIds,
    StartDate: config.startDate,
    EndDate: config.endDate,
    IsActive: config.isActive,
  };

  try {
    // ✅ axiosClient already returns response.data
    const response = await axiosClient.put<
      { message: string } // Type of the unwrapped data
    >("/admin/AdminCredit/UpdateSignupCredits", null, {
      params,
      paramsSerializer: {
        indexes: null,
      },
    });

    // ✅ response is already the data (not AxiosResponse)
    return { message: response as unknown as string };
  } catch (error: any) {
    console.error("Error updating configuration:", error);

    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.detail ||
      "Failed to update InitialSignup configuration";

    throw new Error(errorMessage);
  }
};

